/**
 * Extract company id stamped on a chat thread (context / metadata).
 */
export function companyIdFromThread(thread: {
  context?: Record<string, unknown> | null;
  metadata?: Record<string, unknown> | null;
  artifact_context?: Record<string, unknown> | null;
}): string | null {
  const blobs: unknown[] = [
    thread.context,
    thread.artifact_context,
    thread.metadata,
  ];
  const meta = thread.metadata;
  if (meta && typeof meta === 'object') {
    blobs.push(meta.context, meta.artifact_context);
  }

  for (const blob of blobs) {
    if (!blob || typeof blob !== 'object' || Array.isArray(blob)) continue;
    const rec = blob as Record<string, unknown>;
    for (const key of ['companyId', 'company_id'] as const) {
      const val = rec[key];
      if (val != null && String(val).trim()) {
        return String(val).trim();
      }
    }
  }
  return null;
}

/**
 * When `companyId` is set, keep only threads scoped to that company.
 * Threads with no company stamp are excluded so another company's history
 * cannot linger after a header company switch.
 */
export function filterThreadsByCompanyId<T extends {
  context?: Record<string, unknown> | null;
  metadata?: Record<string, unknown> | null;
  artifact_context?: Record<string, unknown> | null;
}>(threads: T[], companyId: string | null | undefined): T[] {
  const wanted = companyId?.trim();
  if (!wanted) return threads;
  const wantedLower = wanted.toLowerCase();
  return threads.filter((thread) => {
    const existing = companyIdFromThread(thread);
    if (!existing) return false;
    return existing.toLowerCase() === wantedLower;
  });
}
